import React from 'react';
import PropTypes from 'prop-types';
import { useUpdateEffect } from 'react-use';
import cn from 'classnames';

import css from './style.module.scss';

const Cropper = (props) => {
	const {
		children,
		cropHeight,
		isExpanded,
		cropMods,
		onClickExpand,
		expandElem,
	} = props;
	const [isExpandedState, setExpanded] = React.useState(isExpanded);

	const contentRef = React.useRef();

	React.useEffect(() => {
		let timeout;
		if (contentRef.current) {
			timeout = setTimeout(() => {
				const height = contentRef.current.scrollHeight;
				if (height <= cropHeight) {
					setExpanded(true);
				}
			}, 200);
		}
		return () => {
			clearTimeout(timeout);
		};
	}, [cropHeight]);

	useUpdateEffect(() => {
		setExpanded(isExpanded);
	}, [isExpanded]);

	const contentStyle = React.useMemo(() => {
		return isExpandedState
			? {}
			: { maxHeight: cropHeight, overflow: 'hidden' };
	}, [isExpandedState, cropHeight]);

	const handleClickExpand = React.useCallback(
		(e) => {
			if (onClickExpand) onClickExpand.call(null, e);
			setExpanded(!isExpandedState);
		},
		[isExpandedState, onClickExpand],
	);

	return (
		<div
			className={cn(css.block, cropMods, {
				[css.block_expanded]: isExpanded,
			})}
		>
			<div ref={contentRef} className={css.content} style={contentStyle}>
				{children}
			</div>
			{!isExpandedState && (
				<span
					tabIndex={0}
					role="button"
					className={cn(css.more)}
					onClick={handleClickExpand}
				>
					{expandElem}
				</span>
			)}
		</div>
	);
};

Cropper.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
	cropHeight: PropTypes.number,
	isExpanded: PropTypes.bool,
	cropMods: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.string,
	]),
	onClickExpand: PropTypes.func,
	expandElem: PropTypes.element,
};

Cropper.defaultProps = {
	children: undefined,
	cropHeight: 50,
	isExpanded: false,
	cropMods: [],
	onClickExpand: undefined,
	expandElem: undefined,
};

export default Cropper;
